import { useTheme } from '@simplywallst/ui-core';

export const ChartDefinitions = () => {
  const theme = useTheme();
  return (
    <svg style={{ display: 'block', width: 0, height: 0 }}>
      <linearGradient id="positive-chart" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor={theme.color.good} stopOpacity="0.3" />
        <stop offset="90%" stopColor={theme.color.good} stopOpacity="0" />
      </linearGradient>
      <linearGradient id="negative-chart" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor={theme.color.bad} stopOpacity="0.3" />
        <stop offset="90%" stopColor={theme.color.bad} stopOpacity="0" />
      </linearGradient>
    </svg>
  );
};
